module.exports = __webpack_public_path__ + "img/ic-check.dd8d0ce5.svg";